import React from 'react';
import { UserAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';
import EmailVerification from '../components/EmailVerification';

const Home = () => {
    const { user, loading } = UserAuth();
    const { lang } = useLanguage();
    const T = translations[lang].home;
    const Tg = translations[lang];

    if (loading) {
        return (
            <div style={{ padding: "20px", textAlign: "center" }}>
                <h1>{T.title}</h1>
                <p>{Tg.loading}</p>
            </div>
        );
    }

    return(
        <div style={{ padding: "20px" }}>
            <h1>{T.title}</h1>
            {user && (
                <div>
                    <p>{T.refresh}</p>
                    <br/>
                    <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/rUxDfAGm1Qg?si=WU0iqyxJ-_HwZ38k"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            style={{ maxWidth: '100%' }}
                        ></iframe>
                    </div>
                    <p>{T.close}</p>
                    <p>{T.contact}</p>
                    <EmailVerification />
                </div>
            )}
        </div>
    )
}

export default Home;
